
/*
 *
 * Global Api
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 *
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/global/global')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}
export async function getInternationalPrefixes (params) {
  let data

  let logged = false
  if (window.sessionStorage.getItem('jwe')) {
    logged = true
  }

  try {
    data = await axios({
      method: 'get',
      url: !logged ? 'services/registration-service/public/anon/get-international-prefix' : 'services/merchant-service/get-international-prefix',
      data: { ...params }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getMinAppVersion (params) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: `services/configuration-service/prelogin/configuration/getBuildInfo?clientCode=${process.env.BANK === 'NEXIBUSINESS' ? 'NEXI' : process.env.BANK}`,
      data: { ...params }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function sendFirebaseToken (params) {
  let data
  try {
    data = await axios({
      method: 'put',
      url: 'services/merchant-service/user/update-instance-id',
      data: { ...params }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function checkDeepLinking (params) {
  let data
  const type = `?type=${params.payload || ''}` // Set the service key of the deeplinking, ES: COMPANY_DATA

  try {
    data = await axios({
      method: 'get',
      url: `services/marketing-service/user-service/deeplinking-info${type}`,
      data: { ...params }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function events (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/marketing-service/public/events',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
